const getFormDataFromObject = (obj: object): FormData => {
  const formData = new FormData();
  for (const entries of Object.entries(obj)) {
    formData.append(entries[0], entries[1]);
  }

  return formData;
};

export default getFormDataFromObject;
